// const Joi = require('joi');

// const envVarsSchema = Joi.object()
//   .keys({
//     NODE_ENV: Joi.string().valid('production', 'development', 'test', 'local').required(),
//     PORT: Joi.number().default(443),
//     MONGODB_URL: Joi.string().required().description('Mongo DB url'),
//     BUGSNAG_API_KEY: Joi.string().optional().description('Bugsnag api key'),
//     ROOT_URL: Joi.string().required().description('Root url'),
//     CDN_JS_LINK: Joi.string().required().description('Dota js link'),
//     USE_LOCAL_SSL: Joi.bool().optional().default(false),
//     LETS_ENCRYPT_EMAIL: Joi.string().email({ tlds: { allow: false } }),
//     DOTA_API_URL: Joi.string().uri().required().description('Dota api url'),
//     DOTA_API_URL_PROXY: Joi.string().uri().required().description('Dota proxy url'),
//     DOTA_API_TOKEN: Joi.string().required().description('Dota api token'),
//     MONGO_API_URL: Joi.string().uri().required().description('Mongo api url')
//   })
//   .unknown();

// const { value: envVars, error } = envVarsSchema
//   .prefs({ errors: { label: 'key' } })
//   .validate(process.env);

// if (error) {
//   throw new Error(`Config validation error: ${error.message}`);
// }

const rootUrl = process.env.ROOT_URL;
const apiBaseUrl = `${rootUrl}/api`;

module.exports = {
  root_url: rootUrl,
  api_baseurl: apiBaseUrl,
  login_api_url: `${apiBaseUrl}/auth/login`,
  // login_api_url: `${apiBaseUrl}/auth/login`,
  status_api_url: `${apiBaseUrl}/status`,
  page_view_api_url: `${apiBaseUrl}/page-views`,
  // status_api_url: `${apiBaseUrl}/status`,
  context_editor_api: `${apiBaseUrl}/save-translations`,

  // env vars
  env: process.env.NODE_ENV,
  dota_api_url: process.env.DOTA_API_URL,
  dota_api_url_proxy: process.env.DOTA_WEB_API_URL + '/api/proxy',
  disable_livejs_urls: process.env.DISABLE_LIVEJS_URLS,

  // Debugging info
  _log_level: 0,

  // Live Editor Configs
  web_owner: false,

  enable_index_db: false, // process.env.ENABLE_INDEX_DB === 'true' || false,
  // Merge Feature configs
  enable_sentence_merging: false,
  sentence_parents: ['P', 'LI', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6'],
  sentence_children: ['#TEXT', 'SPAN', 'STRONG', 'B', 'I', 'BR', 'A'],
  sentence_nodes: {},
  sentence_nodes_by_orig_text: {},
  sentence_merge_separator_send: ' <span class="tag small tag-open tag-close">||</span> ',
  sentence_merge_separator_receive: '<span class="tag small tag-open tag-close">||</span>',
  sentence: { sentences: [] },

  html_sentence_nodes: {},

  // keep the first time loaded sentence_nodes only - to keep SPA static data through all pages
  spa_sentence_nodes: {},
  // keep the first time loaded arr_nodes only - to keep SPA static data through all pages
  spa_arr_nodes: {},
  spa_first_load_flag: true, // to handle spa_sentence_nodes/spa_arr_nodes assignment in case of SPA

  // Blacklist Feature configs
  enable_blacklist: true,
  blacklist_classes: [],
  blacklist_ids: [],

  /**
   * Client specific configurations
   */
  clients: {
    dummy: {
      enabled: false,
      hostname: 'dummy.com'
    },

    mygov: {
      enabled: false,
      hostname: ['mygov.in', 'xn--11b3cgab9b4bm5d.xn--h2brj9c', 'mygov.devnagri.live']
    },
    wep: {
      enabled: false,
      hostname: ['wep']
    },
    idfcfa: {
      enabled: false,
      hostname: ['idfcfirstacademy']
    },
    prestige: {
      enabled: false,
      hostname: ['devcorporatesite', 'prestigeconstructions']
    },
    bajaj: {
      enabled: false,
      hostname: ['bajajfinservmarkets', 'bfsd.npq.bfsgodirect']
    },
    cub: {
      enabled: false,
      hostname: ['onlineuat.cubuat.bank.in', 'online.cub.bank.in', 'ltest.cubuat.bank.in']
    },
    canara: {
      enabled: false,
      hostname: ['www.canararobeco.com', 'cug.canararobeco.com']
    }
  },

  /**
   * Feature specific configurations
   */
  features: {
    objectMapping: {
      enabled: false
    },
    youtubeIframe: {
      enabled: false
    }
  },
  enable_youtube_iframe: false,
  youtube_iframe_html_tag: 'player',

  api_key: '',
  // script_type: 'livejs_browser',
  default_lang_code: '',
  selected_lang_code: '',
  source_lang_code: '',
  should_render_ui: '',
  _access_token: '',
  // url_object: new URL(document.URL),

  document_url: '',
  // document_url_full: document.URL,
  page_view_api_count: 0,
  subdomainObjectStore: '',
  // expiry_token_time: localStorage.getItem("devnagri_token_expiry_time"),
  subscription_status_active: '',
  enable_object_mapping: false,
  domain: '',
  requested_domain: '',
  subdomain_object_urls_hash_map: {},
  subdomain_object_urls_hash_map_local: {},
  linkedDomains: [],

  translation_api_global_data: false,
  translation_api_global_data_by_local_key: '',
  metatag_key: '',
  // metatag_arr: {
  //   TITLE: {
  //     tag: "TITLE",
  //     engText: document.title,
  //     translatedText: document.title,
  //   },
  // },
  meta_prefix: 'DOTAMETA_',
  translation_api_url: '',
  // update_api_url: "",
  target_lang_code: '',
  status_api_global_data: {},
  db: 'devnagriTranslationText',
  config: '',
  frame_ids: ['nv_box_content-iframe_22196', 'nv_leadform_content-iframe_1810'],
  frames_translation_status_map: {},
  edit_mode_enabled: false,
  arr_nodes: {},
  html_arr_nodes: {},
  translation_api_retry_counter: 3,
  missingTranslationPercentageOffsetForRetry: 100,
  traverse_whole_dom: true,
  arr_translated_text: {},
  update_global_data_timeout: '',

  renderUICounter: 1,
  content_editable: [],
  sentence_merging_initial_url_date: '2022-11-16T06:55:06.113Z',
  sentence_merging_fallback_url_date: '2010-09-14T06:55:06.113Z',
  user_ip: '',
  user_lat: 0,
  user_long: 0,
  lang_status_map: '',
  // dota_token: new URL(document.URL).searchParams.get("dota-token"),

  url_object: '',
  document_url_full: '',
  metatag_arr: {
    TITLE: {
      tag: 'TITLE',
      engText: '',
      translatedText: ''
    }
  },
  dota_token: '',
  expiry_token_time: '',

  // start of proxy side configs

  // traversing_completion_timer : 0,
  destination_lang_code: '',
  accessToken: '',
  // root_url: `${apiBaseUrl}/api`,
  update_api_url: `${apiBaseUrl}/translations`,
  // document_url_full: '',
  requested_full_english_url: '',
  requested_sub_domain: '',
  enableLanguageDropdownUI: false,
  enableSubdomainRedirect: false,
  languageDropdownSubdomains: [],
  document_title: '',
  user_agent: '',
  dropdown_position: {},
  dom: {},
  result: {},
  is_cached: false,
  cached_expire_time: 0,
  is_browser_cached: false,
  page_valid_for_caching: false,
  enable_static_content: false,
  blacklist_data: [],
  enable_whitelist: false,
  whitelist_data: [],
  whitelist_ids: [],
  whitelist_classes: [],
  up_arrow_svg_content:
    '<svg xmlns:"http://www.w3.org/2000/svg" xmlns:xlink:"http://www.w3.org/1999/xlink" width:"17px" height:"17px" viewBox:"0 0 17 17" version:"1.1"><defs><filter id:"alpha" filterUnits:"objectBoundingBox" x:"0%" y:"0%" width:"100%" height:"100%"> <feColorMatrix type:"matrix" in:"SourceGraphic" values:"0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"/></filter><mask id:"mask100"> <g filter:"url(#alpha)"><rect x:"0" y:"0" width:"17" height:"17" style:"fill:rgb(0%,0%,0%),fill-opacity:0.968627,stroke:none,"/> </g></mask><clipPath id:"clip100"> <rect x:"0" y:"0" width:"17" height:"17"/></clipPath><g id:"surface105" clip-path:"url(#clip100)"><path style:" stroke:none,fill-rule:evenodd,fill:rgb(0%,0%,0%),fill-opacity:1," d:"M 8.550781 5.761719 C 8.789062 5.746094 9.003906 5.808594 9.195312 5.949219 C 10.910156 7.433594 12.628906 8.910156 14.347656 10.386719 C 14.550781 10.703125 14.550781 11.023438 14.347656 11.339844 C 14.03125 11.644531 13.6875 11.683594 13.3125 11.457031 C 11.765625 10.144531 10.222656 8.824219 8.6875 7.496094 C 7.152344 8.824219 5.609375 10.144531 4.0625 11.457031 C 3.628906 11.707031 3.261719 11.632812 2.957031 11.238281 C 2.828125 10.941406 2.851562 10.65625 3.027344 10.386719 C 4.746094 8.910156 6.464844 7.433594 8.175781 5.949219 C 8.296875 5.867188 8.421875 5.804688 8.550781 5.761719 Z M 8.550781 5.761719 "/></g></defs><g id:"surface100"><use xlink:href:"#surface105" mask:"url(#mask100)"/></g></svg>',
  devngari_logo_svg_content:
    '<svg xmlns:"http://www.w3.org/2000/svg" xmlns:xlink:"http://www.w3.org/1999/xlink" width:"30px" height:"30px" viewBox:"0 0 30 30" version:"1.1"><defs><filter id:"alpha" filterUnits:"objectBoundingBox" x:"0%" y:"0%" width:"100%" height:"100%"> <feColorMatrix type:"matrix" in:"SourceGraphic" values:"0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"/></filter><mask id:"mask0"> <g filter:"url(#alpha)"><rect x:"0" y:"0" width:"30" height:"30" style:"fill:rgb(0%,0%,0%),fill-opacity:0.960784,stroke:none,"/> </g></mask><clipPath id:"clip1"> <rect x:"0" y:"0" width:"30" height:"30"/></clipPath><g id:"surface5" clip-path:"url(#clip1)"><path style:" stroke:none,fill-rule:evenodd,fill:rgb(27.843137%,60.392157%,83.137255%),fill-opacity:1," d:"M 12.679688 -0.0820312 C 14.171875 -0.0820312 15.664062 -0.0820312 17.15625 -0.0820312 C 18.871094 0.238281 20.5 0.839844 22.042969 1.722656 C 22.40625 2.699219 22.601562 3.707031 22.625 4.753906 C 22.519531 6.222656 22.296875 7.667969 21.960938 9.097656 C 15.101562 9.058594 8.253906 9.058594 1.410156 9.097656 C 2.898438 5.191406 5.605469 2.433594 9.53125 0.820312 C 10.578125 0.4375 11.628906 0.136719 12.679688 -0.0820312 Z M 12.679688 -0.0820312 "/></g><mask id:"mask1"> <g filter:"url(#alpha)"><rect x:"0" y:"0" width:"30" height:"30" style:"fill:rgb(0%,0%,0%),fill-opacity:0.831373,stroke:none,"/> </g></mask><clipPath id:"clip2"> <rect x:"0" y:"0" width:"30" height:"30"/></clipPath><g id:"surface8" clip-path:"url(#clip2)"><path style:" stroke:none,fill-rule:evenodd,fill:rgb(27.843137%,60.392157%,83.137255%),fill-opacity:1," d:"M 25.773438 4.835938 C 27.074219 5.988281 27.960938 7.410156 28.425781 9.097656 C 27.390625 9.015625 26.339844 9.015625 25.277344 9.097656 C 25.566406 7.691406 25.730469 6.273438 25.773438 4.835938 Z M 25.773438 4.835938 "/></g><mask id:"mask2"> <g filter:"url(#alpha)"><rect x:"0" y:"0" width:"30" height:"30" style:"fill:rgb(0%,0%,0%),fill-opacity:0.956863,stroke:none,"/> </g></mask><clipPath id:"clip3"> <rect x:"0" y:"0" width:"30" height:"30"/></clipPath><g id:"surface11" clip-path:"url(#clip3)"><path style:" stroke:none,fill-rule:evenodd,fill:rgb(27.843137%,60.392157%,83.137255%),fill-opacity:1," d:"M 28.921875 18.277344 C 26.078125 25.617188 20.664062 29.03125 12.679688 28.523438 C 6.808594 27.28125 2.886719 23.867188 0.910156 18.277344 C 0.507812 17.003906 0.34375 15.695312 0.414062 14.34375 C 0.382812 13.234375 0.492188 12.140625 0.746094 11.066406 C 7.652344 10.902344 14.558594 10.847656 21.464844 10.902344 C 21.019531 12.988281 20.523438 15.066406 19.972656 17.132812 C 19.09375 16.082031 18.152344 15.070312 17.15625 14.097656 C 14.941406 12.75 12.675781 12.695312 10.359375 13.933594 C 8.136719 15.09375 6.5625 16.8125 5.636719 19.097656 C 5.613281 22.628906 7.300781 25.007812 10.691406 26.230469 C 12.453125 26.613281 14.109375 26.339844 15.664062 25.410156 C 16.628906 24.671875 17.597656 23.933594 18.5625 23.195312 C 18.4375 23.839844 18.300781 24.496094 18.148438 25.164062 C 18.203125 25.273438 18.257812 25.382812 18.316406 25.492188 C 19.199219 25.875 20.082031 26.257812 20.96875 26.640625 C 22.261719 21.453125 23.535156 16.261719 24.777344 11.066406 C 26.214844 10.847656 27.652344 10.847656 29.089844 11.066406 C 29.339844 12.140625 29.449219 13.234375 29.417969 14.34375 C 29.492188 15.695312 29.324219 17.003906 28.921875 18.277344 Z M 28.921875 18.277344 "/></g><mask id:"mask3"> <g filter:"url(#alpha)"><rect x:"0" y:"0" width:"30" height:"30" style:"fill:rgb(0%,0%,0%),fill-opacity:0.956863,stroke:none,"/> </g></mask><clipPath id:"clip4"> <rect x:"0" y:"0" width:"30" height:"30"/></clipPath><g id:"surface14" clip-path:"url(#clip4)"><path style:" stroke:none,fill-rule:evenodd,fill:rgb(27.843137%,60.392157%,83.137255%),fill-opacity:1," d:"M 14.335938 15.328125 C 16.777344 14.933594 18.324219 15.890625 18.976562 18.195312 C 17.332031 20.972656 15.011719 22.992188 12.015625 24.261719 C 10.820312 24.847656 9.660156 24.792969 8.535156 24.097656 C 7.367188 22.707031 7.230469 21.203125 8.121094 19.589844 C 8.640625 18.695312 9.328125 17.957031 10.195312 17.378906 C 11.496094 16.511719 12.878906 15.832031 14.335938 15.328125 Z M 14.335938 15.328125 "/></g><mask id:"mask4"> <g filter:"url(#alpha)"><rect x:"0" y:"0" width:"30" height:"30" style:"fill:rgb(0%,0%,0%),fill-opacity:0.898039,stroke:none,"/> </g></mask><clipPath id:"clip5"> <rect x:"0" y:"0" width:"30" height:"30"/></clipPath><g id:"surface17" clip-path:"url(#clip5)"><path style:" stroke:none,fill-rule:evenodd,fill:rgb(17.647059%,49.803922%,72.941176%),fill-opacity:1," d:"M 0.910156 18.277344 C 2.886719 23.867188 6.808594 27.28125 12.679688 28.523438 C 20.664062 29.03125 26.078125 25.617188 28.921875 18.277344 C 27.480469 24.621094 23.558594 28.503906 17.15625 29.917969 C 15.664062 29.917969 14.171875 29.917969 12.679688 29.917969 C 6.277344 28.503906 2.351562 24.621094 0.910156 18.277344 Z M 0.910156 18.277344 "/></g></defs><g id:"surface1"><use xlink:href:"#surface5" mask:"url(#mask0)"/><use xlink:href:"#surface8" mask:"url(#mask1)"/><use xlink:href:"#surface11" mask:"url(#mask2)"/><use xlink:href:"#surface14" mask:"url(#mask3)"/><use xlink:href:"#surface17" mask:"url(#mask4)"/></g></svg>',

  ui_left: null,
  ui_right: '3%',
  ui_bottom: '4%',

  //for restring apis call
  apiCounter: 0,
  prevURL: '',
  translationData: {},
  objectMappingapiCounter: 0,
  objectMappingData: {},
  sentenceData: {},
  prevSentenceData: [],

  // get translation api conditional variable
  enable_translate_manual_approved_segments: '',

  // check domain setup approach - default is livejs
  isProxySide: false,

  // dota variables
  enable_variable_system: process.env.ENABLE_VARIABLE_SYSTEM === 'true' || false,
  sentenceVariables: {},

  enable_spa_support: process.env.ENABLE_SPA_SUPPORT === 'true' || false,
  enable_page_views: true,

  googleCloudStorageApiUri: process.env.GOOGLE_CLOUD_STORAGE_API_URI,
  googleCloudStorageBucket: process.env.GOOGLE_CLOUD_STORAGE_BUCKET,
  jsonFileCdnPath: process.env.JSON_FILE_CDN_PATH,
  cdnJsonCallCounter: 0,
  enableCloudStorageCache: process.env.ENABLE_CLOUD_STORAGE_CACHE === 'true' || false,

  existingChildXpaths: [],

  scriptJsonLdConfig: {
    enable: false,
    sentences: []
  },

  enableLocalizeActiveUrlsOnly: false,
  activeUrlsData: [],
  domainSDKEnabled: false,

  enableTranslationServiceApi:
    process.env.ENABLE_TRANSLATION_SERVICE_API === 'false' ? true : false,

  enableSaveTranslationApi: process.env.ENABLE_SAVE_TRANSLATION_API !== 'false'
};
